import { FC, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { InputBox } from './input-box';
import { SendAction } from './send-action';

interface ChatInputNamespace extends FC<PropsWithChildren> {
  TextBox: typeof InputBox;
  SendAction: typeof SendAction;
}

export const ChatInput: ChatInputNamespace = ({ children }) => {
  return <div css={styles.container}>{children}</div>;
};

ChatInput.TextBox = InputBox;
ChatInput.SendAction = SendAction;

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing(1, 2)};
  `,
};
